import { render, staticRenderFns } from "./SupplierDetails.vue?vue&type=template&id=64a05fed&scoped=true&"
import script from "./SupplierDetails.vue?vue&type=script&lang=js&"
export * from "./SupplierDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a05fed",
  null
  
)

export default component.exports